import {
  enUS, de, es, fr, it, nl, no,
  pl, pt, ro, ru, tr, zhCN, cs, hr, hu,
  sr, bg, ja, arSA, uk, vi,
} from 'date-fns/locale'

export const dateFnsLocaleMap = {
  en: enUS,
  de,
  de_formal: de,
  es,
  fr,
  it,
  nl,
  no,
  pl,
  pt,
  ro,
  ru,
  tr,
  zh: zhCN,
  cs,
  hr,
  hu,
  sr,
  bg,
  jp: ja, // 'jp' is not a standard code, but 'ja' is for Japanese
  ar: arSA,
  uk,
  vi,
}
